import { useMutation, useQueryClient } from '@tanstack/react-query';

import deleteSchedule from 'Api/schedule/deleteSchedule';
import { useToast } from 'Store/toast';
import { useLoader } from 'Store/loader';

import { useScheduleState } from 'View/schedule/state';

import { deleteScheduleText } from 'Const/schedule';

const useDeleteSchedule = ({ onResetModal, filters }) => {
  const queryClient = useQueryClient();
  const { onOpenToast } = useToast();
  const { onShowLoader, onResetLoader } = useLoader();
  const { updateState, state } = useScheduleState();
  const { selectedEvent } = state;

  return useMutation({
    mutationFn: async (id) => {
      onShowLoader({ variant: 'loader-primary' });

      return await deleteSchedule({ id });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['schedules', filters] });
      queryClient.invalidateQueries({ queryKey: ['schedule-details', selectedEvent] });
      onOpenToast({
        status: 'success',
        position: 'top',
        description: deleteScheduleText?.successText,
        duration: 5,
        alwaysShow: false,
      });
      updateState({ isDialogOpen: false, isDrawerOpen: false });
      onResetModal();
    },
    onError: (err) => {
      const errorMessage = err?.response?.data?.errors[0]?.message ?? '';

      onOpenToast({
        status: 'failed',
        position: 'top',
        title: deleteScheduleText?.failedText,
        description: errorMessage,
        duration: 5,
        alwaysShow: false,
      });
      onResetModal();
    },
    onSettled: () => {
      onResetLoader();
    },
  });
};

export default useDeleteSchedule;
